import React from "react";

import { Button, Dropdown, Input, Radio, RadioGroup } from "rsuite";

export function Accommodations({ data, onChange }) {
  return (
    <>
      <div className="card containerd w-75">
        <div
          style={{ backgroundColor: "rgba(242, 89, 38)" }}
          className="card-header text-white py-3"
        >
          <h2>Accommodation Details</h2>
        </div>
        <div className="card-body p-3 ">
          <style>
            {`
                    .rs-dropdown-toggle, .rs-dropdown-toggle.rs-btn {
        width: 100% !important;
      }
    `}
          </style>
          <Dropdown
            menuStyle={{ overflowY: "scroll", width: "100%" }}
            style={{ padding: "0.5rem 0", width: "100%" }}
            trigger={["click"]}
            title={
              // data?.beds
              //   ? "If you are travelling as a couple : " + data?.beds
              //   :
              "If you are travelling as a couple"
            }
          >
            {["Two Beds", "One Bed"].map((ele) => (
              <Dropdown.Item onClick={() => onChange("beds", ele)}>
                {ele}
              </Dropdown.Item>
            ))}
          </Dropdown>

          <label style={{ fontSize: 14, marginBottom: 10 }}>
            Are you sharing with another guest?
          </label>
          <RadioGroup
            name="sharingOption"
            onChange={(value) => onChange("sharing_accommodation", value)}
            defaultValue={
              data?.sharing_accommodation ? data?.sharing_accommodation : 0
            } // Set the default value to 'No' or 'Yes' based on your requirement
          >
            <Radio value={1}>Yes</Radio>
            <Radio value={0}>No</Radio>
          </RadioGroup>
          <label style={{ fontSize: 14, marginBottom: 10 }}>
            Do you smoke or require a smoking room?
          </label>
          <RadioGroup
            name="smokingRoom"
            onChange={(value) => onChange("require_smoking_room", value)}
            defaultValue={
              data?.require_smoking_room ? data?.require_smoking_room : 0
            } // Set the default value to 'No' or 'Yes' based on your requirement
          >
            <Radio value={1}>Yes</Radio>
            <Radio value={0}>No</Radio>
          </RadioGroup>
        </div>
      </div>
    </>
  );
}
